import { useEffect, useState } from "react";
import { User } from "../../../../imsdk/db/t_user";
import { useChatStore } from "../../../store/ChatStore";
import { setGroupAdmin } from "../../../net/service";
import { TopicUserListRender } from "../TopicUsers";
import { Str_AddAdmin, Str_RemoveAdmin } from "../../../language/string_res";
import { MainNavProps } from "../../navigation/main/MainParamList";
import * as ImSdk from "../../../../imsdk/api";
import { useIsFocused } from "@react-navigation/native";
import { showToast } from "../../../components/Toast";

// 管理员
export const GroupHandleAdmin = ({ navigation, route }: MainNavProps<'GroupHandleAdmin'>) => {
    const isAddAdmin = route.params.isAddAdmin
    const [users, setUsers] = useState<User[]>([]);
    const { chatState } = useChatStore()
    const members = chatState.curTopicWithSummary.users ?? []
    const tid = chatState.curTopicWithSummary.topic.tid;
    const adminSet = chatState.adminSet ?? new Set<number>([])
    const isFocused = useIsFocused()
    const currentUid = ImSdk.getInstance().CurrentUid();
    async function initUserList() {
        const useUsers = members.filter(
            (v) => {
                return isAddAdmin ? !adminSet.has(v.uid) : adminSet.has(v.uid) &&
                    v.uid != currentUid
            }
        );
        setUsers(useUsers as any as User[]);
    }

    useEffect(() => {
        if (isFocused) {
            initUserList().then();
        }
    }, [isFocused]);

    function handleSubmit(uids: number[]) {
        setGroupAdmin({ tid: tid, uids: uids, op: isAddAdmin ? 'set' : 'unset' }).then((res) => {
            if (!res.code) {
                onClose()
            } else {
                res.msg && showToast(res.msg)
                onClose();
            }
        })
    }
    const onClose = () => { navigation.goBack() }
    return (
        <TopicUserListRender
            title={isAddAdmin ? Str_AddAdmin : Str_RemoveAdmin}
            users={users}
            hasRadio={true}
            onClose={onClose}
            onSubmit={handleSubmit}
        />
    );
};
